module.exports = __webpack_public_path__ + "img/issuance-step-3.c0ba37e3.png";